import {
  IFullStressScoringPayload,
  ActionType,
  IFullStressScoringResponse,
} from "models/stressCheck/fullStressScoringInformation";

export const getFullStressScoringAction = (
  payload: IFullStressScoringPayload
) => {
  return {
    type: ActionType.FULL_STRESS_SCORING,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.FULL_STRESS_SCORING_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IFullStressScoringResponse) => {
  return {
    type: ActionType.FULL_STRESS_SCORING_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.FULL_STRESS_SCORING_RESET,
  };
};
